import styled from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';

export const ActionIconButtonStyled = styled(ButtonIcon)`
  margin-left: 0.1rem;
`;
